import SendNda from './SendNda.component';

export default SendNda;